import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=688f29a3&scoped=true&"
import script from "./Tabs.vue?vue&type=script&lang=ts&"
export * from "./Tabs.vue?vue&type=script&lang=ts&"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=688f29a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.nlark.com+vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688f29a3",
  null
  
)

export default component.exports